<template>
	<nut-dialog
		teleport="body"
		:title="title"
		:visible="modelValue"
		@ok="hanldleOK"
		@cancel="hanldleClose"
	>
		<nut-input class="input" placeholder="请输入" v-model="val" />
	</nut-dialog>
</template>

<script>
import { ref, computed } from 'vue';
import { Toast } from '@nutui/nutui';
import { titleMap, userField } from '@/constants';
import { userApi } from '@/apis';
export default {
	name: 'EditInfoModal',
	props: {
		type: {
			required: true,
		},
		modelValue: {
			type: Boolean,
			required: true,
		},
		userInfo: {
			type: Object,
			required: true,
		},
	},
	emits: ['update:modelValue', 'refresh'],
	setup(props, { emit }) {
		// eslint-disable-next-line vue/no-setup-props-destructure
		const initialVal = props.userInfo[userField[props.type]];
		const val = ref(initialVal);
		const title = computed(() => '修改' + titleMap[props.type]);
		const hanldleClose = () => {
			emit('update:modelValue', false);
		};
		const hanldleOK = async () => {
			if (val.value === initialVal) {
				hanldleClose();
				return;
			}
			await userApi.shop_save({
				type: props.type,
				value: val.value,
			});
			Toast.success('修改成功');
			emit('refresh');
			hanldleClose();
		};
		return {
			val,
			title,
			hanldleClose,
			hanldleOK,
		};
	},
};
</script>

<style lang="scss" scoped>
.input {
	padding: 8px 0;
	font-size: $small-font-size;
}
</style>
